import React, { Component } from 'react';
import ReactFileReader from 'react-file-reader';
import './Caricaminore.css';
import { acceptMinorTreatment, updateSkierPictureFetch, updateSkierDocumentFetch } from '../../libs/fetch';
import FirebaseLogger from '../../libs/FirebaseLogger';
import cadr from '../../images/public/registeration/cadr.png';
import clos from '../../images/public/registeration/clos.png';
import agdc from '../../images/public/registeration/agdc.png';
import dcmadded from '../../images/public/userarea/dcmadded.png';
import uploadclose from '../../images/public/userarea/uploadclose.png';
import { element } from 'prop-types';
import classNames from 'classnames';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import { Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle } from 'react-shapes';
import { RadioGroup, Radio } from 'react-radio-group';
import { height } from 'window-size';
import WebFont from 'webfontloader';
import tr from '../../libs/tr'
import AlertPnl from "../../assets/components/panel/AlertPnl";
import ChckBxAccR1 from '../../assets/components/checkbox/ChckBxAccR1'
import WaitLoad from "../../assets/components/loading/WaitLoad";
import ReactLoading from 'react-loading';


//
let activeSkiers;
let activeSkier;

class Caricaminore extends Component {

	constructor(props) {
		super(props);

		this.state = {
			fronte: null,
			retro: null,
			interna: null,
			seniorUpload: true, // It should be true when the senior user want to upload documents TODO: @Ali
			documentType: 0, // by now for mockup only ID doc = 0 , passport = 1   {/* @ale: I used your state to change views for uploading documents. tnx */}
			profile: null,
			postalcodeDoc: null,
			checkBox1: false,
			deletePic: false, // This state is for the popup of the uploaded picture TODO: @Ali
			uploadMode: 0,// 0:initial, 1: profile pic missing, 2: doc missing, 3: postalcode
			submitted: false,
		};

		this.updaloadDocuments = this.updaloadDocuments.bind(this);
		// this.changeUploadview = this.changeUploadview.bind(this);
		this.deletePopup = this.deletePopup.bind(this);
	}

	componentDidMount() {
		activeSkiers = JSON.parse(localStorage.getItem('activeSkier'));
		activeSkier = activeSkiers[0];
		console.log("UPLOAD FORM", activeSkier);

		// to be used in type="zip" when user is asked to insert proof of address 
		this.setState({needForUploadingSkierPicture: !activeSkier.picture});

		function findGetParameter(name) {
			let url = window.location.href;
			name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
			var regexS = "[\\?&]" + name + "=([^&#]*)";
			var regex = new RegExp(regexS);
			var results = regex.exec(url);
			return results == null ? null : results[1];
		}

		let uploadType = findGetParameter("type");
		console.log("uploadType: ", uploadType);
		if (uploadType == "zip") {
				this.setState({ uploadMode: 3 })
		} else {
				this.setSeniorMode(activeSkier.type);
				this.setUploadMode(activeSkier);
		}
	}

	startTO() {
		console.log("#start");
		this.KO = setTimeout(() => {
		this.setState({loading: false});
		this.handleAlert(tr.t("timeoutMessage"));
		console.log("#setTimeout");
		}, 60000);
	};

	stopTO() {
		console.log("#stop");
		this.setState({loading: false});
		clearTimeout(this.KO);
	};

	getFronte = files => {
		console.log(files.base64);
		console.log(files.fileList[0].name);
		let picName = files.fileList[0].name;
		let picType = files.fileList[0].type;
		let suffix = "." + picType.split("/")[1];
		console.log(suffix);
		picName = picName.replace(suffix, "");
		console.log(picName);

		if (picName.length > 18) {
				picName = picName.substr(0, 17);
				picName = picName + '..' + suffix;
		} else {
				picName = picName + suffix;
		};

		console.log(picName);

		this.setState({ fronte: files.base64, frontName: picName });
	}
	getRetro = files => {
		console.log(files.base64);
		console.log(files.fileList[0].name);
		let picName = files.fileList[0].name;
		let picType = files.fileList[0].type;
		let suffix = "." + picType.split("/")[1];
		console.log(suffix);
		picName = picName.replace(suffix, "");
		console.log(picName);

		if (picName.length > 18) {
				picName = picName.substr(0, 17);
				picName = picName + '..' + suffix;
		} else {
				picName = picName + suffix;
		};

		console.log(picName);
		this.setState({ retro: files.base64, backName: picName });
	}
	getPassport = files => {
		console.log(files.base64);
		console.log(files.fileList[0].name);
		let picName = files.fileList[0].name;
		let picType = files.fileList[0].type;
		let suffix = "." + picType.split("/")[1];
		console.log(suffix);
		picName = picName.replace(suffix, "");
		console.log(picName);

		if (picName.length > 23) {
				picName = picName.substr(0, 22);
				picName = picName + '..' + suffix;
		} else {
				picName = picName + suffix;
		};

		console.log(picName);
		this.setState({ fronte: files.base64, retro: files.base64, frontName: picName });
	}

	//getting progfile image
	getProfile = files => {
		console.log(files)
		console.log(files.fileList[0].name);
		let picName = files.fileList[0].name;
		let picType = files.fileList[0].type;
		let suffix = "." + picType.split("/")[1];
		console.log(suffix);
		picName = picName.replace(suffix, "");
		console.log(picName);

		if (picName.length > 23) {
				picName = picName.substr(0, 22);
				picName = picName + '..' + suffix;
		} else {
				picName = picName + suffix;
		};

		console.log(picName);
		this.setState({ profile: files.base64, profileName: picName }); // just blob, w/out info
	}

	//getting progfile image
	getAddressDoc = files => {
		console.log(files)
		console.log(files.fileList[0].name);
		let picName = files.fileList[0].name;
		let picType = files.fileList[0].type;
		let suffix = "." + picType.split("/")[1];
		console.log(suffix);
		picName = picName.replace(suffix, "");
		console.log(picName);

		if (picName.length > 23) {
			picName = picName.substr(0, 22);
			picName = picName + '..' + suffix;
		} else {
			picName = picName + suffix;
		};

		console.log(picName);
		this.setState({ postalcodeDoc: files.base64, postalcodeDocName: picName }); // just blob, w/out info
	}

	validateForm() {
		return (this.state.fronte) && (this.state.retro) && (this.state.profile);
	}

	deletePopup = (e) => {
		console.log(e.target.name);

		this.setState({ deletePic: true, target: e.target.name })
	}

	setSeniorMode = (type) => {
		console.log(type);
		this.setState({ seniorUpload: type.toLowerCase() == 'senior' });
	}

	setUploadMode = (skier) => {
		console.log("setUploadMode: ", skier);

		if (skier.certified == 1 && !skier.picture) {
			return this.setState({ uploadMode: 1 }); //profile picture is missing
		}
		if (skier.certified == 0 && skier.picture) {
			return this.setState({ uploadMode: 2 }); //doc missing
		}
			return this.setState({ uploadMode: 0 }); //doc missing
	}

		// // @ale: I already define this for you to use it when user select passport from dropdown, but you should connect it to the dropdown to change the upload view. tnx
		// changeUploadview = (e) => {
		//     e.preventDefault();
		//     console.log(e.event);


		//     // this.setState({ documentType: 1 })
		// }

		// Upload Documents main Fetch 
		// .Upload all documents serialized in different actions

	updaloadDocuments(event) {
			event.preventDefault();

			this.setState({ uploading: true });
			console.log('UPLOADING')

			if(this.state.uploadMode == 3){
				this.setState({loading: true})
				return this.startUpload();
			}

			if (!this.state.seniorUpload) {
				try {
					let acceptParams = { linked_user_id: activeSkier.id }
					acceptMinorTreatment(this, acceptParams).then((resp) => {
						this.setState({ uploading: false });
						if (resp.status == 'success') {                    // upload front document
								this.startUpload();
						}
						else {
								this.handleAlert(resp.message);
						}
						});
					} catch (e) {
							console.error(e);
					}
			} else {
					this.startUpload();
		}
	}

	startUpload() {
		switch (this.state.uploadMode) {
			case 0://initial mode: all files are needed
				this.setState({ uploading_front: true, uploading_back: true, uploading_profile: true }, () => {
					this.setState({ submitted: true });
				});
				let documentBackParams = {
					type: 'front',
					image: this.state.fronte.split(',')[1],
					linked_user_id: activeSkier.id
				}
				updateSkierDocumentFetch(this, documentBackParams).then((response_front) => {
					this.setState({ uploading_front: false }, () => {
						this.setState({ submitted: true });
					});
					console.log(response_front);
					if (response_front.status = 'success') {
					} else {
						this.handleAlert(response_front.message);
					}
				});

				let documentFrontParams = {
					type: 'back',
					image: (this.state.documentType == 0) ? this.state.retro.split(',')[1] : this.state.fronte.split(',')[1],
					linked_user_id: activeSkier.id
				}
					updateSkierDocumentFetch(this, documentFrontParams).then((response_back) => {
						this.setState({ uploading_back: false }, () => {
							this.setState({ submitted: true });
						});
						console.log(response_back);
						if (response_back.status == 'success') {
						} else {
							this.handleAlert(response_back.message);
						}
					});

					let profileParams = {
						type: 'back',
						image: this.state.profile.split(',')[1],
						linked_user_id: activeSkier.id
					}
					updateSkierPictureFetch(this, profileParams).then((response_profile) => {
						this.setState({ uploading_profile: false }, () => {
						this.setState({ submitted: true });
					});
					console.log(response_profile);
					// this.handleAlert(tr.t("DocsUploaded"));
				});
				break;
			case 1://just profile picture is needed
				this.setState({ uploading_profile: true }, () => {
						this.setState({ submitted: true });
				});

				profileParams = {
						type: 'back',
						image: this.state.profile.split(',')[1],
						linked_user_id: activeSkier.id
				}
				updateSkierPictureFetch(this, profileParams).then((response_profile) => {
						this.setState({ uploading_profile: false }, () => {
								this.setState({ submitted: true });
						});
						console.log(response_profile);
						// this.handleAlert(tr.t("DocsUploaded"));
				});
				break;
			case 2://just documents are needed
				this.setState({ uploading_front: true, uploading_back: true }, () => {
						this.setState({ submitted: true });
				});
				documentBackParams = {
						type: 'front',
						image: this.state.fronte.split(',')[1],
						linked_user_id: activeSkier.id
				}
				updateSkierDocumentFetch(this, documentBackParams).then((response_front) => {
				this.setState({ uploading_front: false }, () => {
						this.setState({ submitted: true });
							});
							console.log(response_front);
							if (response_front.status = 'success') {
							} else {
									this.handleAlert(response_front.message);
							}
					});

					documentFrontParams = {
							type: 'back',
							image: (this.state.documentType == 0) ? this.state.retro.split(',')[1] : this.state.fronte.split(',')[1],
							linked_user_id: activeSkier.id
					}
					updateSkierDocumentFetch(this, documentFrontParams).then((response_back) => {
							this.setState({ uploading_back: false }, () => {
									this.setState({ submitted: true });
							});
							console.log(response_back);

							if (response_back.status == 'success') {
							} else {
									this.handleAlert(response_back.message);
							}
					});
					break;
				case 3:
					// uploading proof of address (postal code document)
					let proofOfAddressParams = {
						type: 'zip_document',
						image: this.state.postalcodeDoc.split(',')[1],
						linked_user_id: activeSkier.id
					}
					this.startTO()
					console.log("proof of address: ", proofOfAddressParams);
					updateSkierDocumentFetch(this, proofOfAddressParams).then((response) => {
					console.log(response);
					if (response.status == 'success') {
						// uploading skier picture if missing
						if (this.state.needForUploadingSkierPicture) {
							let profileParams = {
								type: 'back',
								image: this.state.profile.split(',')[1],
								linked_user_id: activeSkier.id
							}
							updateSkierPictureFetch(this, profileParams).then((response_profile) => {
								this.setState({loading: false });
								this.stopTO();
								console.log(response_profile);
								// this.handleAlert(tr.t("DocsUploaded"));
								if (response.status == 'success') {
									this.setState({ postalcodeDocsUploaded: true });

									// Track document upload success
									const user = JSON.parse(localStorage.getItem('user') || '{}');
									FirebaseLogger.getInstance().regEvent("DOCUMENT_UPLOADED", {
										user_id: user.user_id,
										document_type: 'proof_of_address_and_picture',
										skier_id: activeSkier.id
									}, "SUCCESS");
								} else {
									return this.handleAlert(response.message);
								}
							});
						}
						else {
							this.setState({loading: false });
							this.stopTO();
							this.setState({ postalcodeDocsUploaded: true });

							// Track document upload success
							const user = JSON.parse(localStorage.getItem('user') || '{}');
							FirebaseLogger.getInstance().regEvent("DOCUMENT_UPLOADED", {
								user_id: user.user_id,
								document_type: 'proof_of_address',
								skier_id: activeSkier.id
							}, "SUCCESS");
						}
					}
					else {
						this.stopTO();
						this.setState({loading: false });
						return this.handleAlert(response.message);
					}
				});
				break;
			default:
				break;
		}
	}

	alertResponse(info) {
		switch (info.type) {
			case "closeButton":
				this.setState({ inScreenPopupShow: false, deletePic: false, submitted: false })
				break;
			case "actionButton":
				if (info.option1 == "attention") {
						this.setState({ inScreenPopupShow: false })
						break;
				}
				if (info.option1 == "cancel") {
						this.setState({ deletePic: false })
						break;
				}
				if (info.option1 == "success") {
						return this.props.history.push('/');
				}
				if (info.option2 == "delete") {
					if (this.state.target == 'delFront') {
							this.setState({
									deletePic: false,
									fronte: null,
							})
							break; {/* TODO: @Ali: The second option that is for deleting the uploaded picture. tnx */ }
					}
				if (this.state.target == 'delBack') {
					this.setState({
							deletePic: false,
									retro: null,
							})
							break; {/* TODO: @Ali: The second option that is for deleting the uploaded picture. tnx */ }
					}
					if (this.state.target == 'delProfile') {
								this.setState({
										deletePic: false,
										profile: null,
									})
									break; {/* TODO: @Ali: The second option that is for deleting the uploaded picture. tnx */ }
							}
					}
	}
	// return this.props.history.push('/');

}

// Default browser alert function replacement
	handleAlert = (incomingMsg) => {
		console.log("Incoming message:", incomingMsg);
		this.setState({
			inScreenPopupShow: true,
			inScreenPopupMsg: incomingMsg,
		})
	}

	handleChange = (event) => {
		event.preventDefault();
		console.log(event.target.value);
		this.setState({
			documentType: event.target.value,
			retro: '',
			fronte: ''
		});
	}

	canBeSubmitted = () => {
		var submit = false;

		if (this.state.uploadMode == 3) {
			if (this.state.needForUploadingSkierPicture) {
				return this.state.postalcodeDoc && this.state.profile; 
			}
			return this.state.postalcodeDoc;
		}

		if (this.state.seniorUpload) {
			switch (this.state.uploadMode) {
			case 0://initial mode: all files are needed
					submit = this.state.fronte && this.state.retro && this.state.profile;
					break;
			case 1://just profile picture is needed
					submit = this.state.profile;
					break;
			case 2://just documents are needed
					submit = this.state.fronte && this.state.retro;
					break;
			default:
					submit = false;
					break;
		}
		}
		else
		{
			switch (this.state.uploadMode) {
				case 0://initial mode: all files are needed
					submit = this.state.checkBox1 && this.state.fronte && this.state.retro && this.state.profile;
					break;
				case 1://just profile picture is needed
					submit = this.state.checkBox1 && this.state.profile;
					break;
				case 2://just documents are needed
					submit = this.state.checkBox1 && this.state.fronte && this.state.retro;
					break;
				default:
					submit = false;
					break;
				}
		}
		return submit
	}

	render() {
		return (
			<div>
				<div>
					{
					this.state.uploadMode == 3 ? 
					<BrowserView>
						<div className="sn_upload pt-5">
						<div className="sn_overlay d-lg-none"></div>
							<div className="container">
								<div className="row">
									<div className="col-12 col-lg-8 col-xl-5 col-lg-5 mx-auto">
										<div className="sn_register__container">
											<div className="row">
												<div className="col-12 d-flex justify-content-end pb-2 pb-lg-4">
													<div className="sn_exit">
														<a onClick={() => { return this.props.history.push('/') }}>
															<img src={ clos } />
														</a>
													</div>
												</div>
												<div className="col-12">
													<h5 className="text-center mb-4 mb-lg-5">
														{tr.t("Uploadrequested")}
													</h5>
													<div className="sn_upload__square mx-auto mb-2 mb-lg-3">
														<ReactFileReader
															disabled={this.state.postalcodeDoc}
															fileTypes="file_extension"
															base64={true}
															handleFiles={this.getAddressDoc}>
															<a><img src={this.state.postalcodeDoc ? (dcmadded) : (agdc)} className="img-fluid" /></a>          
														</ReactFileReader>
													</div>
													<div>
														<div><b>{ this.state.postalcodeDocName }</b></div>
													</div>
													<div>
														{tr.t("proofOfAddress")}
													</div>
													{
														this.state.needForUploadingSkierPicture && 
														<div className="mt-3 mt-lg-4">
															<div className="sn_upload__square mx-auto mb-lg-3">
																<ReactFileReader disabled={this.state.profile} base64={true} handleFiles={this.getProfile}>
																	<a><img src={this.state.profile ? (dcmadded) : (agdc)} className="img-fluid" /></a>
																</ReactFileReader>
															</div>
															<div className="">
																<div>{this.state.profileName}</div>
															</div>
															<div className="">
																{tr.t("Recphoto")}
															</div>
														</div>
													}
													<div class="d-flex justify-content-center mt-4 mt-lg-5">
														<button className="sn_btn mx-auto" disabled={!this.canBeSubmitted()} onClick={this.updaloadDocuments}>{tr.t("Upload")}</button>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</BrowserView>
					:
					<BrowserView>
					<div className="sn_upload pt-5">
					<div className="sn_overlay d-lg-none"></div>
						<div className="container">
							<div className="row">
								<div className="col-12 col-lg-8 col-xl-5 mx-auto">
									<div className="sn_register__container">
										<div className="row">
											<div className="col-12 d-flex justify-content-end pb-2 pb-lg-4">
												<div className="sn_exit">
													<a onClick={() => { return this.props.history.push('/') }}>
														<img src={ clos } />
													</a>
												</div>
											</div>
											<div className="col-12 pb-2 pb-lg-4">
												<h4 className="text-center">
													{tr.t("Uploadrequested")}				
												</h4>
											</div>
											<div className="col-12 pb-3 pb-lg-5">
											{
												<select
													disabled={ this.state.uploadMode == 1 }
													style=
													{
														{
															cursor: this.state.uploadMode == 1 ? 'default' : 'pointer',
															color: this.state.uploadMode == 1 ? 'rgba(255, 255, 255, 0.4)' : '' 
														}
													}
													onChange={ this.handleChange }
													className={ "sn_upload__droplist" }
												>
													{this.state.uploadMode == 1 ? <option value={0} className="">{tr.t("Identificationcard_nodoc")}</option> :
														<option value={0} className="">{tr.t("Identificationcard")}</option>}
														<option value={0} className="">{tr.t("Drivinglicense")}</option>
														<option value={1} className="">{tr.t("Passport")}</option>
												</select>
											}
											</div>
											{
												this.state.documentType == 0 ?
												<div className="col-12 d-flex justify-content-around pb-2 pb-lg-4">
													<div className=''>
														<div
															style={{ cursor: (this.state.fronte || this.state.uploadMode == 1) ? 'default' : 'pointer' }}
															className="sn_upload__square mx-auto">
															{
																this.state.fronte &&
																<button name={'delFront'} className="sn_upload__delete_btn" onClick={this.deletePopup}>
																	{tr.t("Delete")}
																</button>
															} {/* TODO: @Ali: The button that is connected to the deletePic popup. tnx */}
															{
																!this.state.fronte && this.state.uploadMode != 1 &&
																<ReactFileReader disabled={ this.state.fronte } base64={ true } handleFiles={ this.getFronte }>
																	<a><img src={ this.state.fronte ? (dcmadded) : (agdc) } className="img-fluid" /></a>
																</ReactFileReader>
															}
															{
																(this.state.fronte || this.state.uploadMode == 1) &&
																<img src={ dcmadded } className="sn_upload__square" />
															}
														</div>

														<div className="mt-2 mt-lg-3">
															{
																(this.state.fronte || this.state.uploadMode == 1)
																?
																<div>{this.state.uploadMode == 1 ? tr.t("AlreadyUploaded") : this.state.frontName}</div>
																:
																<div>
																	{tr.t("Uploadfront")}
																</div>
															}
														</div>
													</div>
													<div>
													<div
														style={{ cursor: (this.state.retro || this.state.uploadMode == 1) ? 'default' : 'pointer' }}
														className="sn_upload__square mx-auto">
														{
															this.state.retro &&
															<button name={'delBack'} className="sn_upload__delete_btn" onClick={this.deletePopup}>
																{tr.t("Delete")}
															</button>
														} {/* TODO: @Ali: The button that is connected to the deletePic popup. tnx */}
														{
															!this.state.retro && this.state.uploadMode != 1 &&
															<ReactFileReader disabled={this.state.retro} base64={true} handleFiles={this.getRetro}>
																<a><img src={this.state.retro ? (dcmadded) : (agdc)} className="img-fluid" /></a>
															</ReactFileReader>
														}
														{(this.state.retro || this.state.uploadMode == 1) && <img src={dcmadded} className="sn_upload__square" />}
													</div>
											
													<div className="mt-2 mt-lg-3">
														{(this.state.retro || this.state.uploadMode == 1) ? <div>{this.state.uploadMode == 1 ? tr.t("AlreadyUploaded") : this.state.backName}</div> : <div>{tr.t("Uploadback")}</div>}
													</div>
													</div>
												</div> : null
											}
											{
												this.state.documentType == 1 ?
												<div className="col-12 d-flex justify-content-center pb-2 pb-lg-4">
													<div>
													<div
														style={{ cursor: this.state.fronte ? 'default' : 'pointer' }}
														className="sn_upload__square mx-auto"
													>
														{
															this.state.fronte && <button name={'delFront'} className="sn_upload__delete_btn" onClick={this.deletePopup}></button>
														} {/* TODO: @Ali: The button that is connected to the deletePic popup. tnx */}
														
														{
														!this.state.fronte &&
														<ReactFileReader disabled={this.state.fronte} base64={true} handleFiles={this.getPassport}>
															<a><img src={this.state.fronte ? (dcmadded) : (agdc)} className="img-fluid" /></a>
														</ReactFileReader>
														}

														{this.state.fronte && <img src={dcmadded} className="sn_upload__square" />}
													</div>
													<div className="mt-2 mt-lg-3">
													{
														this.state.fronte ? <div>{ this.state.frontName }</div> : <div>{ tr.t("Uploadfirst") }</div>
													}
													</div>
												</div>
											</div> : null
											}
											<div className="col-12">
												<div className="mt-5 mb-3">
													{tr.t("Recphoto")}
												</div>
											</div>
											<div className="col-12 d-flex justify-content-center">
												<div
													style={{ cursor: (this.state.profile || this.state.uploadMode == 2) ? 'default' : 'pointer' }}
													className="sn_upload__square"
												>
												{
													this.state.profile &&
													<button name={'delProfile'} className="sn_upload__delete_btn" onClick={this.deletePopup}>
														{tr.t("Delete")}
													</button>
												}
												{/* TODO: @Ali: The button that is connected to the deletePic popup. tnx */}
												{
													!this.state.profile && this.state.uploadMode != 2 &&
													<ReactFileReader disabled={this.state.profile} base64={true} handleFiles={this.getProfile}>
														<a><img src={this.state.profile ? (dcmadded) : (agdc)} className="img-fluid" /></a>
													</ReactFileReader>
												}
												{(this.state.profile || this.state.uploadMode == 2) && <img src={dcmadded} className="sn_upload__square" />}
												</div>
											</div>
											<div className="col-12 mt-4">
											{
												(this.state.profile || this.state.uploadMode == 2) ?
													<div className={this.state.seniorUpload ? "" : ""}>
														<div>{this.state.uploadMode == 2 ? tr.t("AlreadyUploaded") : this.state.profileName}</div>
													</div> : null
											}
											{
												!this.state.seniorUpload &&
												<div>
													<div className="">
														{tr.t("Childiscount")}
													</div>
													<div className="mt-4">
														<ChckBxAccR1
															context1={tr.t("Parent")}
															controller={(checkBox1) => { this.setState({ checkBox1: checkBox1 });
															console.log("checkBox1 father", checkBox1) }}
														/>
													</div>
												</div>
											}
											</div>
											<div className="col-12 d-flex justify-content-center mt-4 mt-lg-5">
												<button className="sn_btn" disabled={!this.canBeSubmitted()} onClick={this.updaloadDocuments}>{tr.t("Next")}</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					<div>
				</div>
			</div>
		</BrowserView>                    
		}
		<MobileView>
		<div className="containermbcgcm">
			<div>&#160;</div>
			<div>&#160;&#160;&#160;&#160;&#160;&#160;Loading...</div>
		</div>
		</MobileView>
	</div>
	<WaitLoad enable={this.state.loading} />
		<div>
		{
			((!this.state.uploading_front && !this.state.uploading_back && !this.state.uploading_profile && this.state.submitted)||(this.state.postalcodeDocsUploaded)) ?
				<div className="containerModalc">
					{((!this.state.uploading_front && !this.state.uploading_back && !this.state.uploading_profile && this.state.submitted)||(this.state.postalcodeDocsUploaded)) ?
						<AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={tr.t("DocsUploaded")} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"medium"} option1={"success"} callback={this.alertResponse.bind(this)} /> : null
					}
					</div> : null
		}
		{
			this.state.inScreenPopupShow ?
				<div className="containerModalc">
						{this.state.inScreenPopupShow ?
								<AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={this.state.inScreenPopupMsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"medium"} option1={"attention"} callback={this.alertResponse.bind(this)} /> : null
						}
				</div> : null
		}
		{
			this.state.deletePic ?
				<div className="containerModalc">
					{this.state.deletePic ?
							<AlertPnl textbar1={" "} secondbar={true} textbar2={tr.t("Deleteimage")} doublebtnhor={true} textbtn1={tr.t("Cancel")} textbtn2={tr.t("Delete")} option1={"cancel"} option2={"delete"} callback={this.alertResponse.bind(this)} /> : null
					} {/* TODO: @Ali: The popup is already connected to buttons, just you should handle the second option to delete the right uploaded picture. tnx */}
				</div> : null
		}
		</div>
		<div style={{ flex: 1 }}>
			{(this.state.uploading_front || this.state.uploading_back || this.state.uploading_profile) &&
				<div className="containerLoading">
					<ReactLoading className="loading" type={'bars'} />
				</div>
			}
		</div>
	</div>
	);
	}
}

export default Caricaminore;
class _checkForTimeOut {
	constructor() {
		this.start = function (timeout = 5000) {
			console.log("[workflow] @_checkForTimeOut #start");
			this.KO = setTimeout(() => {
			console.log("[workflow] @_checkForTimeOut #setTimeout");

		}, timeout);
		};
		this.stop = function () {
			console.log("[workflow] @_checkForTimeOut #stop");
			clearTimeout(this.KO);
		};
	}
}


// WEBPACK FOOTER //
// ./src/screens/Caricaminore/Caricaminore.js